var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationAndActionProblem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-824.000000, -1036.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-and-action/Problem",
    transform: "translate(824.000000, 1036.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,26.9999732 C14.9590179,26.9999732 14.1150324,26.1549657 14.1150324,25.1149564 C14.1150324,24.0739471 14.9590179,23.2299396 16,23.2299396 C17.0409821,23.2299396 17.8849676,24.0739471 17.8849676,25.1149564 C17.8849676,26.1549657 17.0409821,26.9999732 16,26.9999732 M17.8329685,8.03180386 L16.9419838,20.9999196 L15.0580162,20.9999196 L14.2240306,11.7528371 C14.2240306,9.67081849 15.7510043,8.03180386 17.8329685,8.03180386 M31.6877301,26.523969 L18.6109551,3.51576353 C17.4629748,1.49474549 14.5380252,1.49474549 13.3890449,3.51576353 L0.312269936,26.523969 C-0.560715042,28.0589827 0.500266702,30 2.21123726,30 L29.7887627,30 C31.4997333,30 32.560715,28.0589827 31.6877301,26.523969",
    id: 155
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationAndActionProblem);
export default __webpack_public_path__ + "static/media/navigation-and-action-problem.988c5c84.svg";
export { ForwardRef as ReactComponent };